import React, { useState } from "react";
import { useEffect } from "react";
import { checkSaralIdIsExist } from "../../Utils/APIs/checkSaralIdIsExistAPI.js";
import CommonDropdown from "../../Components/common/commonDropdown.js";
import { getCookie } from "../../Utils/cookies.js";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const Index = () => {
  const Navigate = useNavigate();
  const empData = JSON.parse(getCookie("empData"));
  useEffect(() => {
    const token = getCookie("token");
    if (!token) {
      Navigate("/login");
    }
  }, []);
  const [farmerDetails, setFarmerDetails] = useState({});
  const [farmerExist, setFarmerExist] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [saralId, setSaralId] = useState();
  const [complainant, setComplainant] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [authority, setAuthority] = useState("");
  const [priority, setPriority] = useState("");
  const [company, setCompany] = useState("");
  const [complaintDetails, setComplaintDetails] = useState("");
  const [complaintOtherDetails, setComplaintOtherDetails] = useState("");
  const [firCopy, setFirCopy] = useState(null);
  // const [finalFirCopy, setFinalFirCopy] = useState(null);
  const [typesOfStolenProduct, setTypesOfStolenProduct] = useState(null);
  const [estimatedAmount, setEstimatedAmount] = useState(null);
  const [lossDate, setLossDate] = useState(null);
  const [brokenPanelImage, setBrokenPanelImage] = useState(null);
  const [punchnama, setPunchnama] = useState(null);
  const [newsPaper, setNewPaper] = useState(null);
  const [jcr, setJcr] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [responseData, setResponseData] = useState("");
  // error hooks
  const [complainantError, setComplainantError] = useState(false);
  const [contactError, setContactError] = useState(false);
  const [authorityError, setAuthorityError] = useState(false);
  const [priorityError, setPriorityError] = useState(false);
  const [companyError, setCompanyError] = useState(false);
  const [complaintError, setComplaintError] = useState(false);
  const [otherComplaintError, setOtherComplaintError] = useState(false);
  const [firCopyError, setFirCopyError] = useState(false);
  const [stolenProductError, setStolenProductError] = useState(false);
  const [estimatedAmountError, setEstimatedAmountError] = useState(false);
  const [lossDateError, setLossDateError] = useState(false);
  const [brokenPanelImageError, setBrokenPanelImageError] = useState(null);
  const [punchnamaError, setPunchnamaError] = useState(false);
  const [submitBtnDisable, setSubmitBtnDisable] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const isExistSaralId = async () => {
    await checkSaralIdIsExist(
      saralId,
      setFarmerDetails,
      setFarmerExist,
      setResponseMessage,
    );
  };
  const handleAuthorityChange = (authorityName) => {
    setAuthority(authorityName);
  };
  const handleCompanyChange = (companyName) => {
    setCompany(companyName);
  };
  const handleComplaintForm = async (e) => {
    e.preventDefault();
    setSubmitBtnDisable(true);
    setComplainantError(complainant === "");
    setContactError(contact.length < 10);
    setAuthorityError(authority === "");
    setPriorityError(priority === "");
    setCompanyError(company === "");
    setComplaintError(complaintDetails === "");
    if (complaintDetails === "Panel broken") {
      setBrokenPanelImageError(brokenPanelImage === null);
      setPunchnamaError(punchnama === null);
    }
    if (complaintDetails === "Others") {
      setOtherComplaintError(complaintOtherDetails === "");
    }
    if (complaintDetails === "Theft case") {
      setFirCopyError(firCopy === null);
    }
    if (
      complaintDetails === "Theft case" ||
      complaintDetails === "Panel broken"
    ) {
      setStolenProductError(typesOfStolenProduct === null);
      setEstimatedAmountError(estimatedAmount === null);
      setLossDateError(lossDate === null);
    }
    const isBasicValid =
      complainant &&
      contact.length >= 10 &&
      authority &&
      priority &&
      company &&
      complaintDetails;
    const isOtherValid = complaintDetails !== "Others" || complaintOtherDetails;
    const isTheftValid =
      complaintDetails !== "Theft case" ||
      (firCopy && estimatedAmount && lossDate && typesOfStolenProduct);
    const isPanelBrokenValid =
      complaintDetails !== "Panel broken" ||
      (brokenPanelImage &&
        punchnama &&
        estimatedAmount &&
        lossDate &&
        typesOfStolenProduct);
    if (isBasicValid && isOtherValid && isTheftValid && isPanelBrokenValid) {
      const formData = new FormData();
      formData.append("farmerId", farmerDetails?._id);
      formData.append("saralId", farmerDetails?.saralId);
      formData.append("farmerName", farmerDetails?.farmerName);
      formData.append("farmerContact", farmerDetails?.contact);
      formData.append("village", farmerDetails?.village);
      formData.append("district", farmerDetails?.district);
      formData.append("state", farmerDetails?.state);
      formData.append("farmerPin", farmerDetails?.pin);
      formData.append("complainantName", complainant);
      formData.append("contact", contact);
      formData.append("address", address);
      formData.append("pin", pinCode);
      formData.append("authority", authority);
      formData.append("priority", priority);
      formData.append("company", company);
      formData.append(
        "complaintDetails",
        complaintDetails === "Others"
          ? complaintOtherDetails
          : complaintDetails,
      );

      if (complaintDetails === "Theft case") {
        formData.append("firCopy", firCopy);
        // formData.append("firFinalCopy", finalFirCopy);
      }
      if (complaintDetails === "Panel broken") {
        formData.append("brokenPanelImage", brokenPanelImage);
        formData.append("jcr", jcr);
        formData.append("invoice", invoice);
        formData.append("punchnama", punchnama);
        formData.append("newsPaperCutting", newsPaper);
      }
      if (
        complaintDetails === "Panel broken" ||
        complaintDetails === "Theft case"
      ) {
        formData.append("stolenProduct", typesOfStolenProduct);
        formData.append("estimatedAmount", estimatedAmount);
        formData.append("lossDate", lossDate);
      }
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/farmer/addComplaint`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response.status === 200 || response.status === 201) {
          setContact("");
          setAddress("");
          setPinCode("");
          setAuthority("");
          setComplaintDetails("");
          setComplainant("");
          setEstimatedAmount(null);
          setLossDate(null);
          // setFarmerDetails({});
          setSaralId("");
          setFarmerExist(false);
          // reset other fields as needed
          setResponseData(response?.data?.message);
          setResponseMessage("");
          setSubmitBtnDisable(false);
        }
      } catch (error) {
        setSubmitBtnDisable(false);
        console.error("Complaint submission failed:", error.response || error);
      }
    }else{
        setSubmitBtnDisable(false);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const sendRequest2 = await axios.get(
          `${process.env.REACT_APP_API_URL}/common/showErrorList`,
        );
        setErrorList(sendRequest2.data.data);
      } catch (error) {
        console.log("Something went wrong");
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <div className="h-full flex flex-col overflow-auto ">
        <div>
          <h1 className=" text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg">
            C<span className="text-lg">OMPLAINT</span> R
            <span className="text-lg">EGISTRATION</span>
          </h1>
        </div>
        <div className="grid gap-3 m-6 md:grid-cols-4">
          <div>
            <label
              for="saral_id"
              className="block mb-2 text-sm font-medium text-gray-900 "
            >
              Saral ID<span className="text-red-500 relative h-3">*</span>
            </label>
            <input
              type="text"
              id="saral_id"
              onChange={(e) => {
                setSaralId(e.target.value);
              }}
              value={saralId}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
              placeholder="Saral Id"
              required
            />
          </div>
          <div>
            {saralId && (
              <button
                type="button"
                onClick={isExistSaralId}
                className="text-white mt-7 bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
              >
                Find
              </button>
            )}
          </div>
          <div>
            <h1
              className="text-2xl tracking-widest "
              style={{
                color:
                  responseMessage === "Farmer Exist"
                    ? "rgb(0, 250, 0)"
                    : "rgb(255, 0, 0)",
              }}
            >
              {responseMessage}
            </h1>
          </div>
        </div>
        {farmerDetails && Object.keys(farmerDetails).length > 0 ? (
          <table className=" table-relative bg-white border mx-6 border-gray-300 rounded-lg">
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                Saral Id:
              </th>{" "}
              <td className="text-gray-700">{farmerDetails?.saralId}</td>{" "}
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Warranty Expired Date :
              </th>
              <td className="text-gray-700 text-red-600">
                {farmerDetails.warrantyExpiredDate}
              </td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                Farmer:
              </th>{" "}
              <td className="text-gray-700">{farmerDetails.farmerName}</td>{" "}
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Coordinates :
              </th>
              <td className="text-gray-700">
                {farmerDetails.longitude + "," + farmerDetails.latitude}
              </td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                Contact_No.{" "}
              </th>{" "}
              <td className="text-gray-700 select-none pointer-events-none">
                {farmerDetails.contact}
              </td>
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Installation Date :
              </th>
              <td className="text-gray-700">
                {farmerDetails.installationDate}
              </td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                State :
              </th>
              <td className="text-gray-700">{farmerDetails.state}</td>
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Department :
              </th>
              <td className="text-gray-700">{farmerDetails.department}</td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                District :
              </th>
              <td className="text-gray-700">{farmerDetails.district}</td>
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Product :
              </th>
              <td className="text-gray-700">
                {farmerDetails.HP + "HP " + farmerDetails.AC_DC}
              </td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                Block :
              </th>
              <td className="text-gray-700">{farmerDetails.block}</td>
              <th className="text-left pl-6 text-gray-700 font-semibold">
                Village :
              </th>
              <td className="text-gray-700">{farmerDetails.village}</td>
            </tr>
          </table>
        ) : (
          ""
        )}
        <form onSubmit={handleComplaintForm}>
          <div className="grid gap-3 m-6 md:grid-cols-4">
            <div>
              <label
                for="first_name"
                className="block mb-2 text-sm font-medium text-gray-900 "
              >
                Complainant Name
                <span className="text-red-500 relative h-3">*</span>
              </label>
              <input
                type="text"
                id="first_name"
                value={complainant}
                onChange={(e) => {
                  setComplainant(e.target.value);
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                placeholder="Complainant Name"
              />
              {complainantError && (
                <span className="text-red-500 text-xs ml-2">
                  Complainant Name are required.
                </span>
              )}
            </div>
            <div>
              <label
                for="contact"
                className="block mb-2 text-sm font-medium text-gray-900 "
              >
                Alternate Contact Number
                <span className="text-red-500 relative h-3">*</span>
              </label>
              <input
                type="number"
                id="contact"
                value={contact}
                onChange={(e) => {
                  setContact(e.target.value);
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                placeholder="Contact Number"
              />
              {contactError && (
                <span className="text-red-500 text-xs ml-2">
                  Contact number are most be 10 digits required.
                </span>
              )}
            </div>
            <div>
              <label
                for="address"
                className="block mb-2 text-sm font-medium text-gray-900 "
              >
                Address (If change)
              </label>
              <input
                type="text"
                id="address"
                value={address}
                onChange={(e) => {
                  setAddress(e.target.value);
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                placeholder="Address"
              />
            </div>
            <div>
              <label
                for="pin"
                className="block mb-2 text-sm font-medium text-gray-900 "
              >
                PIN CODE
              </label>
              <input
                type="text"
                id="pin"
                value={pinCode}
                onChange={(e) => {
                  setPinCode(e.target.value);
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                placeholder="Pin code"
              />
            </div>
            <div>
              <label
                for="authority"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                AUTHORITY<span className="text-red-500 relative h-3">*</span>
              </label>
              <CommonDropdown
                Api_path={"common/showAuthority"}
                value={authority}
                onChange={handleAuthorityChange}
                label={"Authority"}
              />
              {authorityError && (
                <span className="text-red-500 text-xs ml-2">
                  Select any one Authority.
                </span>
              )}
            </div>
            <div>
              <label
                for="priority"
                className="block mb-2 text-sm font-medium text-gray-900 "
              >
                PRIORITY<span className="text-red-500 relative h-3">*</span>
              </label>
              <select
                onChange={(e) => {
                  setPriority(e.target.value);
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                id="state-select"
              >
                <option value="">-- select Priority --</option>
                <option key={1} value="Normal">
                  Normal
                </option>
                <option key={1} value="Urgent">
                  Urgent
                </option>
                <option key={1} value="Most Urgent">
                  Most Urgent
                </option>
              </select>
              {priorityError && (
                <span className="text-red-500 text-xs ml-2">
                  Select Priority
                </span>
              )}
            </div>
            <div>
              <label
                for="company"
                className="block mb-2 text-sm font-medium text-gray-900 "
              >
                Choose Company Name
                <span className="text-red-500 relative h-3">*</span>
              </label>
              <CommonDropdown
                Api_path={"common/showCompany"}
                value={company}
                onChange={handleCompanyChange}
                label={"Company"}
              />
              {companyError && (
                <span className="text-red-500 text-xs ml-2">
                  Select Company
                </span>
              )}
            </div>
            <div className="">
              <label
                for="first_name"
                className="block mb-2 text-sm font-medium text-gray-900 "
              >
                Complaint Types
                <span className="text-red-500 relative h-3">*</span>
              </label>
              <select
                onChange={(e) => {
                  setTypesOfStolenProduct(null);
                  setComplaintDetails(e.target.value);
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                id="state-select"
              >
                <option value="">-- Select --</option>
                {errorList.map(({ _id, remark }) => (
                  <option key={_id} value={remark}>
                    {remark}
                  </option>
                ))}
              </select>
              {complaintError && (
                <span className="text-red-500 text-xs ml-2">
                  Select complainant types.
                </span>
              )}
            </div>
            {complaintDetails === "Others" && (
              <div>
                <label
                  for="details"
                  className="block mb-2 text-sm font-medium text-gray-900  "
                >
                  Complaint Details
                  <span className="text-red-500 relative h-3">*</span>
                </label>
                <input
                  type="text"
                  id="first_name"
                  value={complaintOtherDetails}
                  onChange={(e) => {
                    setComplaintOtherDetails(e.target.value);
                  }}
                  className=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                  placeholder="Complaint Details"
                />
                {otherComplaintError && (
                  <span className="text-red-500 text-xs ml-2">
                    Write Complaint details.
                  </span>
                )}
              </div>
            )}
            {complaintDetails === "Panel broken" && (
              <>
                <div>
                  <label
                    htmlFor="media"
                    className="block mb-2 text-sm font-medium text-gray-900  "
                  >
                    Broken Panel Image
                    <span className="text-red-500 relative h-3">*</span>
                  </label>
                  <input
                    type="file"
                    id="media"
                    accept="image/*"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                    onChange={(e) => {
                      // handle file upload here
                      // e.target.files[0] contains the selected file
                      setBrokenPanelImage(e.target.files[0]);
                    }}
                  />
                  {brokenPanelImageError && (
                    <span className="text-red-500 text-xs ml-2">
                      Explain damage items.
                    </span>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="media"
                    className="block mb-2 text-sm font-medium text-gray-900  "
                  >
                    Punchnama
                    <span className="text-red-500 relative h-3">*</span>
                  </label>
                  <input
                    type="file"
                    id="media"
                    accept="image/*"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                    onChange={(e) => {
                      // handle file upload here
                      // e.target.files[0] contains the selected file
                      setPunchnama(e.target.files[0]);
                    }}
                  />
                  {punchnamaError && (
                    <span className="text-red-500 text-xs ml-2">
                      Please upload Punchnama.
                    </span>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="media"
                    className="block mb-2 text-sm font-medium text-gray-900  "
                  >
                    News Paper Cutting
                  </label>
                  <input
                    type="file"
                    id="media"
                    accept="image/*"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                    onChange={(e) => {
                      // handle file upload here
                      // e.target.files[0] contains the selected file
                      setNewPaper(e.target.files[0]);
                    }}
                  />
                </div>
                <div>
                  <label
                    htmlFor="media"
                    className="block mb-2 text-sm font-medium text-gray-900  "
                  >
                    JCR(pdf)
                  </label>
                  <input
                    type="file"
                    id="media"
                    accept="application/pdf"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                    onChange={(e) => {
                      // handle file upload here
                      // e.target.files[0] contains the selected file
                      setJcr(e.target.files[0]);
                    }}
                  />
                </div>
                <div>
                  <label
                    htmlFor="media"
                    className="block mb-2 text-sm font-medium text-gray-900  "
                  >
                    Invoice(pdf)
                  </label>
                  <input
                    type="file"
                    id="media"
                    accept="application/pdf"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                    onChange={(e) => {
                      // handle file upload here
                      // e.target.files[0] contains the selected file
                      setInvoice(e.target.files[0]);
                    }}
                  />
                </div>
              </>
            )}
            {complaintDetails === "Theft case" && (
              <>
                <div>
                  <label
                    htmlFor="media"
                    className="block mb-2 text-sm font-medium text-gray-900  "
                  >
                    FIR Copy<span className="text-red-500 relative h-3">*</span>
                  </label>
                  <input
                    type="file"
                    id="media"
                    accept="application/pdf"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                    onChange={(e) => {
                      // handle file upload here
                      // e.target.files[0] contains the selected file
                      setFirCopy(e.target.files[0]);
                    }}
                  />
                  {firCopyError && (
                    <span className="text-red-500 text-xs ml-2">
                      Please upload fir copy.
                    </span>
                  )}
                </div>
                {/* <div>
                                    <label htmlFor="media" className="block mb-2 text-sm font-medium text-gray-900  ">
                                        FIR Final Copy
                                    </label>
                                    <input
                                        type="file"
                                        id="media"
                                        accept="image/*"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                                        onChange={(e) => {
                                            // handle file upload here
                                            // e.target.files[0] contains the selected file
                                            setFinalFirCopy(e.target.files[0])
                                        }}
                                    />
                                </div> */}
              </>
            )}
            {(complaintDetails === "Theft case" ||
              complaintDetails === "Panel broken") && (
              <>
                <div>
                  <label
                    htmlFor="media"
                    className="block mb-2 text-sm font-medium text-gray-900  "
                  >
                    Damage Item
                    <span className="text-red-500 relative h-3">*</span>
                  </label>
                  <input
                    type="text"
                    id="media"
                    value={typesOfStolenProduct}
                    onChange={(e) => {
                      setTypesOfStolenProduct(e.target.value);
                    }}
                    className=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                    placeholder="Explain damage items"
                  />
                  {stolenProductError && (
                    <span className="text-red-500 text-xs ml-2">
                      Explain damage items.
                    </span>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="media"
                    className="block mb-2 text-sm font-medium text-gray-900  "
                  >
                    Estimated Loss Amount
                    <span className="text-red-500 relative h-3">*</span>
                  </label>
                  <input
                    type="Number"
                    id="media"
                    value={estimatedAmount}
                    onChange={(e) => {
                      setEstimatedAmount(e.target.value);
                    }}
                    className=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                    placeholder="Write total estimated amount"
                  />
                  {estimatedAmountError && (
                    <span className="text-red-500 text-xs ml-2">
                      Explain damage items.
                    </span>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="theftDate"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Date of Loss
                    <span className="text-red-500 relative h-3">*</span>
                  </label>
                  <input
                    type="date"
                    id="theftDate"
                    value={lossDate || ""}
                    onChange={(e) => {
                      setLossDate(e.target.value);
                    }}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                  />
                  {lossDateError && (
                    <span className="text-red-500 text-xs ml-2">
                      Explain damage items.
                    </span>
                  )}
                </div>
              </>
            )}
          </div>
          <div
            className="px-6 flex justify-between items-center gap-4"
            style={{ marginTop: -20 }}
          >
            {farmerExist &&
              ["Super Admin", "Tollfree"].includes(empData.role) && (
                <button
                  type="Submit"
                  disabled={submitBtnDisable}
                  className="text-white mt-2 bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                >
                  Submit
                </button>
              )}
            <p style={{ width: "100%", color: "rgb(1, 231, 1)" }}>
              {responseData}
            </p>
          </div>
        </form>
      </div>
    </>
  );
};

export default Index;
